import React from 'react';
import PropTypes from 'prop-types';

const TraderaLogo = ({ width, height, className, style, ...otherProps }) => (
    <svg
        data-nav-logo=""
        role="img"
        aria-labelledby="Tradera"
        viewBox="0 0 142 19"
        width={width}
        height={height}
        className={className}
        style={style}
        {...otherProps}>
        <title id="traderaTitle">Tradera</title>
        <path d="m30.6 0c5.2 0 7.8 3 7.8 7 0 2.1-.9 3.8-2.5 5 1.3.2 2.3 1.1 2.3 2.4v4.6h-4.4v-4.6c0-.6-.5-1-1.3-1h-.5s-.1 0-.2 0h-.4c-.1 0-.1 0-.2 0h-.4c-.1 0-.2 0-.2 0h-.5c-.8 0-1.6 0-2.4 0h-.5c-.2 0-.5 0-.7 0h-.4c-.1 0-.1 0-.2 0h-.4-.1-.1v5.6h-4.4v-19zm81.8 0c5.2 0 7.8 3 7.8 7 0 2.1-.9 3.8-2.5 5 1.3.2 2.3 1.1 2.3 2.4v4.6h-4.4v-4.6c0-.6-.5-1-1.3-1h-.5s-.1 0-.2 0h-.4c-.1 0-.1 0-.2 0h-.4c-.1 0-.2 0-.2 0h-.5c-.8 0-1.6 0-2.4 0h-.5c-.2 0-.5 0-.7 0h-.4c-.1 0-.1 0-.2 0h-.4-.1-.1v5.6h-4.4v-19zm-93.5 0v4.3h-7.2v14.7h-4.5v-14.7h-7.2v-4.3zm80.6 0v4.3h-11.7v3h9.8v4h-9.8v3.5h11.7v4.2h-16.1v-19zm-29.3 0c7.1 0 10.7 3.1 10.7 9.4 0 5.9-3.8 9.6-10.8 9.6h-7.6v-19zm65.7 0 6.1 19h-4.5l-1.4-4.3h-8.6l-1.4 4.3h-4.5l6.1-19zm-81.5 0 6.1 19h-4.5l-1.4-4.3h-8.6l-1.4 4.3h-4.5l6.1-19zm15.7 4.3h-3.2v10.5h3.2c4.4 0 6.4-1.6 6.4-5.3 0-3.6-2-5.2-6.4-5.2zm62.7 0h-1.9l-2.1 6.5h6zm-81.6 0h-1.9l-2.1 6.5h6zm-20.6 0h-5.3v5.4h5.3c2.3 0 3.3-1 3.3-2.7 0-2-1.1-2.7-3.3-2.7zm81.8 0h-5.3v5.4h5.3c2.3 0 3.3-1 3.3-2.7 0-2-1.1-2.7-3.3-2.7zm28-4.3.4 1 .4-1h.7v2.2h-.5v-1.7l-.4 1.1h-.4l-.5-1.2v1.7h-.4v-2.1zm-1 0v.4h-.7v1.7h-.5v-1.7h-.7v-.4z" />
    </svg>
);
TraderaLogo.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    style: PropTypes.object
};
TraderaLogo.defaultProps = {
    width: 100,
    className: ''
};

export default React.memo(TraderaLogo);
